module.exports = __webpack_public_path__ + "static/media/ab2.3349967d.jpeg";